import React from 'react'
import NewSubCategory from './NewSubCategory'

const AddSubCategory = () => {
    return (
        <NewSubCategory />
    )
}

export default AddSubCategory